// El backend manda la fecha ya formateada como "DD/MM/YYYY HH:MM:SS", pero el
// servidor corre 6 horas adelantado (UTC) respecto a la hora real de México
// (-06:00). Se le restan 6 horas aquí, solo para mostrarla, sin tocar el backend.
export function restarSeisHoras(fechaTexto) {
  if (!fechaTexto) return fechaTexto;

  const match = fechaTexto.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/);
  if (!match) return fechaTexto;

  const [, dia, mes, anio, horas, minutos, segundos] = match;
  const fecha = new Date(
    Number(anio),
    Number(mes) - 1,
    Number(dia),
    Number(horas),
    Number(minutos),
    Number(segundos),
  );
  fecha.setHours(fecha.getHours() - 6);

  const dd = String(fecha.getDate()).padStart(2, "0");
  const mm = String(fecha.getMonth() + 1).padStart(2, "0");
  const yyyy = fecha.getFullYear();
  const hh = String(fecha.getHours()).padStart(2, "0");
  const mi = String(fecha.getMinutes()).padStart(2, "0");
  const ss = String(fecha.getSeconds()).padStart(2, "0");
  return `${dd}/${mm}/${yyyy} ${hh}:${mi}:${ss}`;
}
